var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticClass: "head" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("h5", [_vm._v("上下线")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.line,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "line", $$v)
                    },
                    expression: "form.line",
                  },
                },
                _vm._l(_vm.lines, function (item) {
                  return _c("el-option", {
                    key: item.line,
                    attrs: { label: item.label, value: item.line },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("语言")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.language,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language",
                  },
                },
                _vm._l(_vm.languages, function (item) {
                  return _c("el-option", {
                    key: item.language,
                    attrs: { label: item.label, value: item.language },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.empty } },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/home/banner/add",
                  expression: "'/home/banner/add'",
                },
              ],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "30px" },
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "序号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.isShow == scope.row.id
                      ? _c("el-input", {
                          directives: [{ name: "focus", rawName: "v-focus" }],
                          attrs: {
                            type: "text",
                            autofocus: true,
                            maxlength: "9",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.bindSeq(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.seq,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "seq", $$v)
                            },
                            expression: "scope.row.seq",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow != scope.row.id,
                            expression: "isShow  != scope.row.id",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeSeq(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.seq))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "图片标题",
              "show-overflow-tooltip": "",
              prop: "name",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "图片描述",
              "show-overflow-tooltip": "",
              prop: "description",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "语言",
              prop: "language",
              formatter: _vm.languageFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "按钮标识",
              prop: "buttonFlag",
              formatter: _vm.buttonFlagFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "按钮标题",
              "show-overflow-tooltip": "",
              prop: "buttonName",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "按钮链接",
              "show-overflow-tooltip": "",
              prop: "buttonLink",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "上线/下线",
              prop: "line",
              formatter: _vm.lineFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作人", prop: "updateUser" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作时间",
              width: "170",
              prop: "updateTime",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "function-icon" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/banner/update",
                                expression: "'/home/banner/update'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "修改",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/amend.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.change(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/banner/delete",
                                expression: "'/home/banner/delete'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "删除",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/delete.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dele(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/banner/online",
                                expression: "'/home/banner/online'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "上线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/online.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.online(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/banner/unline",
                                expression: "'/home/banner/unline'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "下线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/offline.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.offline(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "预览",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/view.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.preview(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              "page-size": 10,
              total: _vm.total,
              "current-page": _vm.currentPage,
            },
            on: { "current-change": _vm.changepage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "新增", visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: function ($event) {
              return _vm.addClose("addform")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                model: _vm.addform,
                rules: _vm.rules,
                "status-icon": true,
                "show-message": false,
                "hide-required-asterisk": "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "序号", "label-width": _vm.formLabelWidth } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", maxlength: "9" },
                    model: {
                      value: _vm.addform.seq,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "seq", $$v)
                      },
                      expression: "addform.seq",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "语言", "label-width": _vm.formLabelWidth } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.addform.language,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "language", $$v)
                        },
                        expression: "addform.language",
                      },
                    },
                    _vm._l(_vm.languages, function (item) {
                      return _c("el-option", {
                        key: item.language,
                        attrs: { label: item.label, value: item.language },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题",
                    "label-width": _vm.formLabelWidth,
                    prop: "name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "name", $$v)
                      },
                      expression: "addform.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述",
                    "label-width": _vm.formLabelWidth,
                    prop: "description",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "description", $$v)
                      },
                      expression: "addform.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "PC字体颜色",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.addform.colorPc,
                          callback: function ($$v) {
                            _vm.$set(_vm.addform, "colorPc", $$v)
                          },
                          expression: "addform.colorPc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端字体颜色",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.addform.colorMobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.addform, "colorMobile", $$v)
                          },
                          expression: "addform.colorMobile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "按钮标志",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "Y" },
                      on: { change: _vm.buttonFlag },
                      model: {
                        value: _vm.addform.buttonFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "buttonFlag", $$v)
                        },
                        expression: "addform.buttonFlag",
                      },
                    },
                    [_vm._v("有")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "N" },
                      model: {
                        value: _vm.addform.buttonFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "buttonFlag", $$v)
                        },
                        expression: "addform.buttonFlag",
                      },
                    },
                    [_vm._v("无")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.addform.buttonFlag == "Y"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "链接标志",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "0" },
                          model: {
                            value: _vm.addform.buttonInnerOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "buttonInnerOut", $$v)
                            },
                            expression: "addform.buttonInnerOut",
                          },
                        },
                        [_vm._v("官网")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.addform.buttonInnerOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "buttonInnerOut", $$v)
                            },
                            expression: "addform.buttonInnerOut",
                          },
                        },
                        [_vm._v("其他")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addform.buttonInnerOut == "0" && _vm.addform.buttonFlag == "Y"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "链接类型",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addform.productId,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "productId", $$v)
                            },
                            expression: "addform.productId",
                          },
                        },
                        _vm._l(_vm.recommendType, function (item) {
                          return _c("el-option", {
                            key: item.recommendId,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.addform.buttonInnerOut == "1" &&
                _vm.addform.buttonFlag == "Y") ||
              (_vm.addform.buttonInnerOut == "0" &&
                _vm.addform.buttonFlag == "Y")
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "按钮名称",
                            "label-width": _vm.formLabelWidth,
                            prop: "buttonName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.addform.buttonName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "buttonName", $$v)
                              },
                              expression: "addform.buttonName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addform.buttonInnerOut == "1" && _vm.addform.buttonFlag == "Y"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "按钮链接",
                            "label-width": _vm.formLabelWidth,
                            prop: "buttonLink",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.addform.buttonLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "buttonLink", $$v)
                              },
                              expression: "addform.buttonLink",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片(1920*1000)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture1,
                          },
                        },
                        [
                          _vm.imageUrl1
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl1 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动图片(750*1524)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture2,
                          },
                        },
                        [
                          _vm.imageUrl2
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl2 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addClose("addform")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: {
                    click: function ($event) {
                      return _vm.sure("addform")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改",
            visible: _vm.dialogFormVisibles,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisibles = $event
            },
            close: function ($event) {
              return _vm.changeClose("addform")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                model: _vm.addform,
                rules: _vm.rules,
                "status-icon": true,
                "show-message": false,
                "hide-required-asterisk": "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "语言", "label-width": _vm.formLabelWidth } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择", disabled: true },
                      model: {
                        value: _vm.addform.language,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "language", $$v)
                        },
                        expression: "addform.language",
                      },
                    },
                    _vm._l(_vm.languages, function (item) {
                      return _c("el-option", {
                        key: item.language,
                        attrs: { label: item.label, value: item.language },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题",
                    "label-width": _vm.formLabelWidth,
                    prop: "name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "name", $$v)
                      },
                      expression: "addform.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述",
                    "label-width": _vm.formLabelWidth,
                    prop: "description",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "description", $$v)
                      },
                      expression: "addform.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "PC字体颜色",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.addform.colorPc,
                          callback: function ($$v) {
                            _vm.$set(_vm.addform, "colorPc", $$v)
                          },
                          expression: "addform.colorPc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端字体颜色",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-color-picker", {
                        model: {
                          value: _vm.addform.colorMobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.addform, "colorMobile", $$v)
                          },
                          expression: "addform.colorMobile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "按钮标志",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "Y" },
                      on: { change: _vm.buttonFlag },
                      model: {
                        value: _vm.addform.buttonFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "buttonFlag", $$v)
                        },
                        expression: "addform.buttonFlag",
                      },
                    },
                    [_vm._v("有")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "N" },
                      model: {
                        value: _vm.addform.buttonFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "buttonFlag", $$v)
                        },
                        expression: "addform.buttonFlag",
                      },
                    },
                    [_vm._v("无")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.addform.buttonFlag == "Y"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "链接标志",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "0" },
                          model: {
                            value: _vm.addform.buttonInnerOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "buttonInnerOut", $$v)
                            },
                            expression: "addform.buttonInnerOut",
                          },
                        },
                        [_vm._v("官网")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.addform.buttonInnerOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "buttonInnerOut", $$v)
                            },
                            expression: "addform.buttonInnerOut",
                          },
                        },
                        [_vm._v("其他")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.addform.buttonInnerOut == "1" &&
                _vm.addform.buttonFlag == "Y") ||
              (_vm.addform.buttonInnerOut == "0" &&
                _vm.addform.buttonFlag == "Y")
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "按钮名称",
                            "label-width": _vm.formLabelWidth,
                            prop: "buttonName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.addform.buttonName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "buttonName", $$v)
                              },
                              expression: "addform.buttonName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addform.buttonInnerOut == "1" && _vm.addform.buttonFlag == "Y"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "按钮链接",
                            "label-width": _vm.formLabelWidth,
                            prop: "buttonLink",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              type: "text",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.addform.buttonLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.addform, "buttonLink", $$v)
                              },
                              expression: "addform.buttonLink",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addform.buttonInnerOut == "0" && _vm.addform.buttonFlag == "Y"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "链接类型",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.addform.productId,
                            callback: function ($$v) {
                              _vm.$set(_vm.addform, "productId", $$v)
                            },
                            expression: "addform.productId",
                          },
                        },
                        _vm._l(_vm.recommendType, function (item) {
                          return _c("el-option", {
                            key: item.recommendId,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片(1920*1000)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture1,
                          },
                        },
                        [
                          _vm.imageUrl1
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl1 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动图片(750*1524)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture2,
                          },
                        },
                        [
                          _vm.imageUrl2
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl2 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeClose("addform")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: {
                    click: function ($event) {
                      return _vm.keep("addform")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }